import * as React from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { AiOutlineClose } from "react-icons/ai";
import { Slide } from "@mui/material";
import { createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "./firebase";
import { getAuth, updateProfile } from "firebase/auth"

export default function SignupForm({ language, isOpen, isClose }) {
  const [open, setOpen] = useState(false);
  const [activeState, setActiveState] = useState(0);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [checkPass, setCheckPass] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [hasReloaded, setHasReloaded] = useState(false); // Flag to track reload

  const validateEmail = (email) => {
    // Use a regular expression to validate the email pattern
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const validatePasswordMatch = (pass, checkPass) => {
    return pass === checkPass && pass.length > 7;
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsValidEmail(validateEmail(newEmail));
  };

  const handlePassChange = (e) => {
    const newPass = e.target.value;
    setPass(newPass);
    setIsValidPassword(validatePasswordMatch(newPass, checkPass));
  };

  const handleCheckPassChange = (e) => {
    const newCheckPass = e.target.value;
    setCheckPass(newCheckPass);
    setIsValidPassword(validatePasswordMatch(pass, newCheckPass));
  };
  const onSubmit = async () => {
    if (!isValidEmail || !isValidPassword) {
      return;
    }
    await createUserWithEmailAndPassword(auth, email, pass)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        // setDisplayName(user.displayName);
        // signOut(auth)
        //   .then(() => {
        //     // Sign-out successful.
        //     user = null;
        //     window.location.reload();
        //     console.log("window_reloaded");
        //   })
        //   .catch((error) => {
        //     // An error happened.
        //     console.log(error);
        //   });
        window.location.reload();
        handleClose();

        // ...
      })

      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode);
        alert(errorMessage);
        console.log(errorMessage);
        // ..
      });

    // const auth = getAuth();
    await updateProfile(auth.currentUser, {
      displayName: displayName,
      // photoURL: "https://example.com/jane-q-user/profile.jpg",
    })
      .then(() => {
        // Profile updated!
        // ...
      })
      .catch((error) => {
        // An error occurred
        // ...
      });

    handleClose();

    if (!hasReloaded) {
      setHasReloaded(true);
      if (hasReloaded) {
        window.location.reload();
        setHasReloaded(false);
      }
      console.log("window_reloaded");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    setIsSubmitDisabled(!(isValidEmail && isValidPassword));
  }, [isValidEmail, isValidPassword]);

  return (
    <div>
      {language === "en" && (
        <button
          onClick={handleClickOpen}
          className="pl-1 mt-1 text-gray-500 hover:text-orange-500 pr-4"
          type="submit"
        >
          {" "}
          Sign Up
        </button>
      )}
      {language === "hi" && (
        <button
          onClick={handleClickOpen}
          className="pl-1 mt-1 text-gray-500 hover:text-orange-500 pr-4"
          type="submit"
        >
          {" "}
          साइन अप करें।
        </button>
      )}
      <div className="hidden sm:inline-block">
        <Dialog
          open={open || isOpen}
          onClose={isClose}
          transitionDuration={700}
          TransitionComponent={Slide}
        >
          <div className="flex flex-row h-[600px]">
            <div className="flex border-2 w-[40%]">
              <div className="flex flex-col justify-between items-center justify-center">
                <div></div>
                <div></div>
                <div className="flex items-center">
                  <p className="p-8 bg-orange-500 rounded-full text-3xl text-white px-11">
                    S
                  </p>
                </div>
                <div className="pl-8">
                  <div className="space-y-3">
                    {language === "en" && <p className="text-xl">Sign Up</p>}
                    {language === "hi" && (
                      <p className="text-xl">साइन अप करें।</p>
                    )}
                    <hr className="border-1 w-[90%]" />
                    {language === "en" && (
                      <p className="flex flex-wrap w-[80%]">
                        We do not share your personal details with anyone.
                      </p>
                    )}
                    {language === "hi" && (
                      <p className="flex flex-wrap w-[80%]">
                        हम आपके व्यक्तिगत विवरणों को किसी के साथ साझा नहीं करते
                        हैं।
                      </p>
                    )}
                  </div>
                </div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            {/* {activeState === 0 ? (
            <div className="flex flex-col justify-between">
              <DialogContent className="flex flex-col justify-between items-end w-[140%] text-gray-400">
                <button
                  onClick={handleClose}
                  className="hover:text-white hover:bg-red-600 rounded-md hover:rounded-md transition ease-in-out duration-300"
                  >
                  <AiOutlineClose />
                </button>
                  <button></button>
              </DialogContent>
              <DialogContent className="space-y-6 w-[140%]">
                <TextField
                  // autoFocus
                  margin="dense"
                  id="name"
                  label="Mobile Number"
                  type="tel"
                  fullWidth
                  variant="standard"
                  required={true}
                  minlength={100000000}
                  maxlength={9999999999}
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                />
              </DialogContent>
              <DialogContent />
              <DialogContent className="flex flex-col space-y-4 w-[140%]">
                <button onClick={() => setActiveState(activeState + 1)} className="px-2 py-1 bg-orange-500 rounded-sm text-white font-semibold shadow-md hover:bg-orange-400 transition ease-in-out duration-300">
                  Continue
                </button>
                <div className="flex justify-center">
                  <button className="transition ease-in-out duration-500 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                    Existing User? Log In
                  </button>
                </div>
              </DialogContent>
              <DialogContent />
            </div>
          ) :  */}

            {/* activeState === 1 ? (
            <div className="flex flex-col justify-between">
 <DialogContent className="flex flex-col justify-between items-end w-[140%] text-gray-400">
                <button
                  onClick={handleClose}
                  className="hover:text-white hover:bg-red-600 rounded-md hover:rounded-md transition ease-in-out duration-300"
                  >
                  <AiOutlineClose />
                </button>
                  <button></button>
              </DialogContent>
              <DialogContent className="space-y-6 w-[140%] mt-2">
                <div className="relative">
                <TextField
                  // autoFocus
                  margin="dense"
                  id="displayName"
                  label="Mobile Number"
                  type="tel"
                  fullWidth
                  variant="standard"
                  required={true}
                  minlength={100000000}
                  maxlength={9999999999}
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                />
                <button onClick={() => setActiveState(activeState - 1)} className="absolute transition ease-in-out duration-300 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                  Change ?
                </button>
                </div>
                
                <div className="relative">
                <TextField
                  // autoFocus
                  margin="dense"
                  id="name"
                  label="OTP Sent to Mobile"
                  type="tel"
                  fullWidth
                  variant="standard"
                  required={true}
                  minlength={100000000}
                  maxlength={9999999999}
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                />
                <button className="absolute transition ease-in-out duration-300 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                Resend ?
                </button>
              </div>
              </DialogContent>
              <DialogContent className="flex flex-col space-y-4 w-[140%] mb-3">
                <button onClick={() => setActiveState(activeState + 1)} className="px-2 py-1 bg-orange-500 rounded-sm text-white font-semibold shadow-md hover:bg-orange-400 transition ease-in-out duration-300">
                  Continue
                </button>
                <div className="flex justify-center">
                  <button className="transition ease-in-out duration-500 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                    Existing User? Log In
                  </button>
                </div>
              </DialogContent>
              <DialogContent className="mb-2" />
            </div>
          ) :  */}

            <div className="flex flex-col justify-between w-[60%]">
              <DialogContent className="flex justify-end w-[94%] text-gray-400">
                <button
                  onClick={handleClose || isClose}
                  className="hover:text-white hover:bg-red-600 rounded-md hover:rounded-md transition ease-in-out duration-300"
                >
                  <AiOutlineClose />
                </button>
              </DialogContent>
              <DialogContent className="space-y-6 w-[94%]">
                <TextField
                  // autoFocus
                  margin="dense"
                  id="displayName"
                  label="NAME"
                  onChange={(e) => setDisplayName(e.target.value)}
                  type="text"
                  fullWidth
                  variant="standard"
                  required={true}
                />

                <TextField
                  // autoFocus
                  onChange={handleEmailChange}
                  margin="dense"
                  id="email"
                  label="EMAIL (OPTIONAL)"
                  type="email"
                  fullWidth
                  variant="standard"
                  error={!isValidEmail}
                  helperText={!isValidEmail && "Please enter a valid email"}
                />

                <TextField
                  // autoFocus
                  onChange={handlePassChange}
                  margin="dense"
                  id="name"
                  label="SET PASSWORD"
                  type="tel"
                  fullWidth
                  variant="standard"
                  required={true}
                  error={!isValidPassword}
                  helperText={!isValidPassword && "Passwords do not match"}
                />

                <TextField
                  // autoFocus
                  onChange={handleCheckPassChange}
                  margin="dense"
                  id="name"
                  label="CONFIRM PASSWORD"
                  type="text"
                  fullWidth
                  variant="standard"
                  required={true}
                  error={!isValidPassword}
                />
              </DialogContent>
              <DialogContent className="flex flex-col space-y-4 w-[95%]">
                {language === "en" && (
                  <button
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                    className={`px-2 py-1  rounded-sm text-white font-semibold bg-orange-500 ${
                      isSubmitDisabled
                        ? "pointer-events-none opacity-50"
                        : "shadow-md hover:bg-orange-400 transition ease-in-out duration-300"
                    }`}
                  >
                    Sign Up
                  </button>
                )}
                {language === "hi" && (
                  <button
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                    className={`px-2 py-1  rounded-sm text-white font-semibold bg-orange-500 ${
                      isSubmitDisabled
                        ? "pointer-events-none opacity-50"
                        : "shadow-md hover:bg-orange-400 transition ease-in-out duration-300"
                    }`}
                  >
                    साइन अप करें।
                  </button>
                )}
              </DialogContent>
              <DialogContent className="mb-2" />
            </div>
            {/* } */}
            {/* <div className="absolute flex flex-row justify-center">
            <button onClick={() => setActiveState(activeState - 1)}>
              Prev
            </button>
            <button onClick={() => setActiveState(activeState + 1)}>
              Next
            </button>
          </div> */}
          </div>
        </Dialog>
      </div>

      {/* MoBile View */}
      <div className="sm:hidden">
        <Dialog
          open={open || isOpen}
          onClose={handleClose}
          transitionDuration={700}
          TransitionComponent={Slide}
          className="sm:hidden"
        >
          <div>
            <DialogContent className="flex absolute right-2 top-0 justify-end text-gray-400">
              <button
                onClick={isClose || handleClose}
                className="hover:text-white hover:bg-red-600 rounded-md hover:rounded-md transition ease-in-out duration-300"
              >
                <AiOutlineClose />
              </button>
            </DialogContent>
            <div>
              <div className="flex flex-row">
                <div className="flex items-center justify-between">
                  <p className="p-8 bg-orange-500 rounded-full text-3xl text-white px-11 scale-75">
                    S
                  </p>
                  <div className="pl-8 pt-8">
                    <div className="space-y-3">
                      <p className="text-xl">Sign Up</p>
                      <hr className="border-1 w-[90%]" />
                      <p className="flex flex-wrap w-[80%]">
                        We do not share your personal details with anyone.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex pr-4">
              <div className="flex flex-col justify-between w-[90%]">
                <DialogContent className=" w-[120%]">
                  <TextField
                    // autoFocus
                    margin="dense"
                    id="displayName"
                    label="NAME"
                    onChange={(e) => setDisplayName(e.target.value)}
                    type="text"
                    fullWidth
                    variant="standard"
                    required={true}
                  />

                  <TextField
                    // autoFocus
                    onChange={handleEmailChange}
                    margin="dense"
                    id="email"
                    label="EMAIL (OPTIONAL)"
                    type="email"
                    fullWidth
                    variant="standard"
                    error={!isValidEmail}
                    helperText={!isValidEmail && "Please enter a valid email"}
                  />

                  <TextField
                    // autoFocus
                    onChange={handlePassChange}
                    margin="dense"
                    id="name"
                    label="SET PASSWORD"
                    fullWidth
                    variant="standard"
                    required={true}
                    error={!isValidPassword}
                    helperText={!isValidPassword && "Passwords do not match"}
                  />

                  <TextField
                    // autoFocus
                    onChange={handleCheckPassChange}
                    margin="dense"
                    id="name"
                    label="CONFIRM PASSWORD"
                    type="text"
                    fullWidth
                    variant="standard"
                    required={true}
                    error={!isValidPassword}
                  />
                </DialogContent>
                <DialogContent className="flex flex-col w-[95%]">
                  <button
                    onClick={onSubmit}
                    disabled={isSubmitDisabled}
                    className={`px-2 py-1  rounded-sm text-white font-semibold bg-orange-500 ${
                      isSubmitDisabled
                        ? "pointer-events-none opacity-50"
                        : "shadow-md hover:bg-orange-400 transition ease-in-out duration-300"
                    }`}
                  >
                    Sign Up
                  </button>
                </DialogContent>
                <DialogContent className="mb-2" />
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
}
